import React from 'react';
import PropTypes from 'prop-types';

import Form from 'Components/Form';

const TeacherLoginForm = ({ initialFieldSettings, messagePosition }) => (
  <Form
    type="teacherLogin"
    id="teacherLogin"
    formStyle="login"
    messagePosition={messagePosition}
    submitButtonType="primary"
    initialFieldSettings={initialFieldSettings}
  />
);

TeacherLoginForm.propTypes = {
  messagePosition: PropTypes.string,
  initialFieldSettings: PropTypes.shape({
    username: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

TeacherLoginForm.defaultProps = {
  messagePosition: 'inline-form',
};

export default TeacherLoginForm;
